const n = "0123456789abcdef";
function a(r) {
  let t = "";
  for (let e = 0; e < r; e++) {
    const o = Math.floor(
      Math.random() * Math.floor(n.length)
    );
    t += n[o];
  }
  return t;
}
function c() {
  return `h_${a(10)}`;
}
export {
  c as generateHeadingId
};
